import React from 'react';
import { translate, raiseErrorToast } from '@fiverr-private/machine_translation';
import pathfinder from '@fiverr-private/pathfinder';
import { metric } from '@fiverr-private/perseus';
import Logger from '../../logger';
import { ERROR_CONTEXT, METRIC_COUNT_PATH } from './constants';

export const translateUGC = async({ content, sourceInfo }) => {
    try {
        const translateURL = pathfinder('gig_page_translate_ugc');
        const params = {
            text: content,
            url: translateURL,
            retry: true,
            sourceInfo
        };

        const { translatedBlob } = await translate(params);

        return translatedBlob;
    } catch (e) {
        const logger = Logger.getInstance();

        metric.count(METRIC_COUNT_PATH);
        logger.error(e, { context: ERROR_CONTEXT });

        raiseErrorToast();
    }
};
